<template>
  <div class="card p-2" style="max-width:340px;margin:10px;">
    <h5 class="card-title">Eigenschaften Knoten</h5>
    <span class="text-muted">{{ node.id }}</span>
    <div class="btn-toolbar" role="toolbar">
      <button @click="updateData" class="btn btn-sm btn-primary">Update</button>
    </div>
    <div class="form-group">
      <label>Name</label>
      <input type="text" class="form-control" v-model="node.name"/>
    </div>
    <div v-if="node.class=='script'" class="form-group">
      <label>Script Task</label>
      <div class="input-group">
        <select @changed="updateParameter" class="form-control" v-model="node.script">
          <option v-for="s in scripts" :key="s.id" :value="s.id">{{ s.id }}</option>
        </select>
        <div v-if="node.script" class="input-group-append">
          <a :href="'/trendshop.proxy.web/scripttasks/' + encodeURIComponent(node.script)" target="_blank"><button class="btn btn-primary">...</button></a>
        </div>
      </div>
      <hr/>
      <div v-for="(p,key) in scriptEntry.input" :key="key" class="form-group">
        <label>{{ p.name }}</label>
        <div class="input-group">
          <input :placeholder="p.hint" type="text" v-model="node.inputs[key]" class="form-control" />
          <div class="input-group-append">
            <button @click="selectVariable(key)" class="btn btn-primary">...</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="node.class=='remoteservice'" class="form-group">
      <h4>Remote Service</h4>
      <div class="form-group">
        <label>Service</label>
        <input type="text" class="form-control" v-model="node.serviceKey"/>
      </div>
      <div class="form-group">
        <label>Controller</label>
        <input type="text" class="form-control" v-model="node.controller"/>
      </div>
      <div class="form-group">
        <label>Aktion</label>
        <input type="text" class="form-control" v-model="node.method"/>
      </div>
      <button @click="selectService(key)" class="btn btn-primary">Service wählen...</button>
      <hr/>
      <div v-for="(p,key) in serviceEntry.input" :key="key" class="form-group">
        <label>{{ p.name }}</label>
        <div class="input-group">
          <input :placeholder="p.dataType" type="text" v-model="node.inputs[key]" class="form-control" />
          <div class="input-group-append">
            <button @click="selectVariable(key)" class="btn btn-secondary">...</button>
            <button v-if="!p.dataType.startsWith('java')" @click="openParamEditor(serviceEntry,node,key)" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
          </div>
        </div>
        <b-form-text v-if="p.hint">{{ p.hint }}</b-form-text>
      </div>
    </div>
    <div v-if="node.class=='data'" class="form-group">
      <label>Tabelle</label>
      <select class="form-control" v-model="node.datatable">
        <option v-for="t in tables" :key="t" :value="t">{{ t }}</option>
      </select>
    </div>
    <div class="wrapper" v-else-if="node.class=='dataexport'">
      <div class="form-group">
        <label>Datenquelle</label>
        <select class="form-control" v-model="node.exportsource">
          <option v-for="(val,key) in variables.datasource" :key="key" :value="val.name">{{ val.name }}</option>
        </select>
      </div>
      <ExportConfigWidget :config="node"/>
    </div>
    <div v-if="node.class=='datafilter'" class="wrapper">
      <div class="form-group">
        <label>Datenquelle:</label>
        <select class="form-control" v-model="node.filtersource">
          <option v-for="(val,key) in variables.datasource" :key="key" :value="val.name">{{ val.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Filterausdruck:</label>
        <input type="text" class="form-control" v-model="node.filterquery"/>
        <small>Feldname komplett klein geschrieben und Leerschritte ersetzen mit "_"</small>
      </div>
    </div>
    <div v-if="node.class=='datasort'" class="wrapper">
      <div class="form-group">
        <label>Datenquelle:</label>
        <select class="form-control" v-model="node.sortsource">
          <option v-for="(val,key) in variables.datasource" :key="key" :value="val.name">{{ val.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Feld:</label>
        <input type="text" class="form-control" v-model="node.sortfield"/>
      </div>
      <div class="form-group">
        <label>Ascending:</label>
        <input type="checkbox" class="form-control" v-model="node.sortasc"/>
      </div>
    </div>
    <b-modal id="varSelector" hide-footer>
      <BFlowVariableSelector @selected="updateVariable" :graph="graph" :scripts="scriptCache" :variables="variables"/>
    </b-modal>
    <b-modal id="serviceSelector">
      <BFlowRemoteServiceSelector :registry="serviceRegistry" @selected="updateServiceSelection"/>
    </b-modal>
    <b-modal id="typedParam" @ok="updateParam">
      <BFlowTypedParamEditor ref="typedParam" :data="editParamData" :dataType="editParamType"/>
    </b-modal>
  </div>
</template>

<script>
import tasks from '@/modules/scripttasks.js';
import ExportConfigWidget from '@/components/genericdata/ExportConfigWidget.vue'
import BFlowVariableSelector from '@/components/digitalfirm/BFlowVariableSelector.vue'
import BFlowRemoteServiceSelector from '@/components/digitalfirm/BFlowRemoteServiceSelector.vue'
import BFlowTypedParamEditor from '@/components/digitalfirm/BFlowTypedParamEditor.vue'

export default {
  name: 'BFlowTaskProps',
  props: ["node","scripts","tables","graph","variables","serviceRegistry","serviceDataTypes"],
  data() {
    return {
      editParamType: { "attrs": [] },
      editParamData: {},
      paramId: false,
      nodeCopy: {},
      scriptCache: {},
      serviceCache: {},
      scriptEntry: { id: '', input: [] },
      serviceEntry: { id: '', input: [] }
    }
  },
  components: {
    ExportConfigWidget,
    BFlowVariableSelector,
    BFlowRemoteServiceSelector,
    BFlowTypedParamEditor
  },
  watch: {
    "node": function() {
      console.log('node update');
      //console.log(update.class);
      this.nodeCopy = JSON.parse(JSON.stringify(this.node));
      console.log(this.nodeCopy);
      this.signalUpdate();
    }
  },
  mounted() {
    this.$emit('reqvars',this.node.id);
    this.signalUpdate();
  },
  methods: {
    // props watch not working
    signalUpdate() {


      console.log('signal update: ');
      this.$emit('reqvars',this.node.id);
      if (this.node.script)
        this.updateScript();
      if (this.node.serviceKey)
        this.updateService();
      this.$forceUpdate();
    },
    updateScript() {
      if (this.node.script && this.scriptEntry.id !== this.node.script) {
        if (this.scriptCache[this.node.script]) {
          this.scriptEntry = this.scriptCache[this.node.script];
        } else {
          var self = this;
          tasks.load(this,this.node.script,function(data) {
            self.scriptEntry = data;
            self.scriptCache[self.node.script] = data;
          });
        }
      }
    },
    updateData() {
      this.$emit('update');
    },
    updateParameter() {
      console.log(this.scripts);
      console.log(this.node.script);
    },
    updateVariable(update) {
      if (this.paramId) {
        this.node.inputs = this.node.inputs || {};
        if (update.type == 'data') {
          this.node.inputs[this.paramId] = update.value.name;
        } else if (update.type == 'var') {
          this.node.inputs[this.paramId] = '$' + update.node + '.' + update.value.name;
        } else {
          console.warn('Unbekannter update type: ' + update.type);
        }
        this.paramId = false;
      }
      this.$forceUpdate();
      this.$bvModal.hide('varSelector');
    },
    selectVariable(id) {
      this.paramId = id;
      this.$bvModal.show('varSelector');
    },
    updateService() {
      console.log('update service');
      var sentry = this.serviceRegistry[this.node.serviceKey];
      if (sentry) {
        var ctrl = sentry[this.node.controller];
        if (ctrl) {
          var method = ctrl[this.node.method];
          if (method) this.serviceEntry = method;
        }
      }
    },
    updateServiceSelection(key,ctrl,method,service) {
      console.log('Update service: ',key,ctrl,method,service);
      this.node.serviceKey = key;
      this.node.controller = ctrl;
      this.node.method = method;
      this.serviceEntry = service;
      this.$bvModal.hide('serviceSelector');
      this.$forceUpdate();
    },
    openParamEditor(service,node,key) {
      console.log('OPEN',service,node,key);
      console.log('KEY',service.input[key]);
      if (this.serviceDataTypes) {
        var dataType = this.serviceDataTypes[service.input[key].dataType];
        if (dataType) {
          this.editParamType = dataType;
          this.editParamData = node.inputs[key] || {};
          for (var k in this.editParamData) {
            console.log(k,typeof this.editParamData[k]);
            if (typeof this.editParamData[k] === 'object') {
              this.editParamData[k + '_parsed'] = true;
              this.editParamData[k] = JSON.stringify(this.editParamData[k]);
            }
          }
          this.nodeCopy = node;
          this.paramId  = key;
          console.log('edit type: ',dataType,this.$refs.typedParam);

          this.$bvModal.show('typedParam');
        }
      } else {
        console.warn('No data types from service registry given.')
      }
    },
    updateParam() {
      console.log('update node param',this.nodeCopy,this.paramId,this.editParamData);
      if (this.nodeCopy && this.paramId && this.editParamData) {
        for (var k in this.editParamData) {
          console.log(k);
          if (this.editParamData[k] && this.editParamData[k + '_parsed']) {
            this.editParamData[k] = JSON.parse(this.editParamData[k]);
          }
          delete this.editParamData[k + '_parsed'];
        }
        this.editParamData['ts-native'] = true;
        this.nodeCopy.inputs[this.paramId] = JSON.parse(JSON.stringify(this.editParamData));
      }
    },
    selectService() {
      this.$bvModal.show('serviceSelector');
    }
  }
}
</script>
